module.exports = __webpack_public_path__ + "static/media/anger_issues.4eebc216.jpg";